import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type CallContact } from 'entities/Call/model/CallContact'
import styles from '../styles.module.scss'

type ITimeWaitBottomProps = {
  item: CallContact
}

export const TimeWaitBottom: FC<ITimeWaitBottomProps> = observer(({ item }) => (
  <Typography className={styles.item__desc} variant={'body-xs-regular'} ariaLabel={'timeWait'}>
    {item.timeWait}
  </Typography>
))
